import {
  INITIATE_LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
} from "../../actionTypes/auth";

const INITIAL_STATE = {
  isUserLoggedIn: Boolean(localStorage.getItem("authToken")),
  isLoading: false,
  error: "",
  userProfile: localStorage.getItem("user_profile")
    ? JSON.parse(localStorage.getItem("user_profile"))
    : null,
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INITIATE_LOGIN:
      return { ...state, isLoading: true };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isUserLoggedIn: true,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        isUserLoggedIn: false,
      };
    case "LOGOUT":
      return {
        isUserLoggedIn: false,
        isLoading: false,
        error: "",
      };

    case "SET_USER_PROFILE":
      return {
        ...state,
        userProfile: action.payload,
      };
    default:
      return { ...state };
  }
};

export default reducer;
